// @ts-ignore
import React from "react";
// import { Navigate, useNavigate } from "react-router"
import backButtonIcon from "../../assets/svg/left-arrow.svg";
type BackButtonProps = {
  onClick?: () => void;
};

export function BackButton({ onClick }: BackButtonProps) {
  return (
     <button
      type="button"
      onClick={onClick}
      className=" w-[40px] h-[40px] flex justify-center items-center !z-[9999] cursor-pointer rounded-full outline-none bg-[#1E1E1E]"
    >
      <img width={16} height={16} alt="back button" src={backButtonIcon} />
    </button>
  )
}
